import PublicContentBase from '../../ContentBase'
import './Styles.scss'

const PublicContentPro = (): JSX.Element => {
    return <PublicContentBase />
}

export default PublicContentPro
